/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
"use client";

import React from "react";

const HowItWorks = () => {
const cards = [
  {
    id: 1,
    title: "Create Your Concierge",
    description:
      "Start your free AskLocal concierge and tell us where you are in your journey.",
    image: "/agnet.png",
  },
  {
    id: 2,
    title: "Build Your Team",
    description:
      "Connect with trusted local professionals when you’re ready — on your terms.",
    image: "/girlAgent.png",
  },
  {
    id: 3,
    title: "Move Forward with Confidence",
    description:
      "Get clear guidance, organized communication, and support from start to close.",
    image: "/groupAgent.png",
  },
];

  return (
    <section className="w-full bg-white py-16 sm:py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto text-center">
        {/* --- Heading --- */}
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[80px] xl:text-7xl judson-regular text-[#000000] mb-5 leading-snug">
         A simpler way to move <br />forward
        </h1>

        <p className="text-[#938E8E] inter-regular text-sm sm:text-base md:text-lg max-w-3xl mx-auto mb-12 sm:mb-14 leading-relaxed px-2">
          FINALLY – A clear path to closing. Despite technological advances and the efforts of many great professionals,
          the process remains fragmented and unclear. That’s why we’ve reimagined the experience with solutions built
          around your needs.
        </p>

        {/* --- Cards Section --- */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mt-10">
          {cards.map((card) => (
            <div
              key={card.id}
              className="relative rounded-2xl p-[3px] bg-linear-to-b from-[#227ABB] via-[#227ABB]/70 to-transparent hover:from-[#3b82f6] hover:via-[#3b82f6]/70 hover:to-transparent transition-all duration-700"
            >
              <div className="bg-white rounded-2xl p-4 sm:p-5 md:p-6 h-full text-left">
                <img
                  src={card.image}
                  className="w-full h-48 sm:h-56 md:h-60 lg:h-64 object-cover rounded-xl mb-4 sm:mb-5"
                />
                <h3 className="text-lg sm:text-xl font-semibold text-[#000000] mb-2">
                  {card.title}
                </h3>
                <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
